import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from './messages';

import {
  None,
  AddressServiceRequested,
  ForwardingServiceRequested,
  ChangeServiceRequested,
  ReturnServiceRequested,
} from '../../../../../../src/orders/other-shipping-options/constants/dhl-ecommerce/ancillary-endorsement';

const mapForMessages = {
  [None]: <FormattedMessage {...messages.endorsementNone} />,
  [AddressServiceRequested]: <FormattedMessage {...messages.endorsementAddressServiceRequested} />,
  [ForwardingServiceRequested]: <FormattedMessage {...messages.endorsementForwardingServiceRequested} />,
  [ChangeServiceRequested]: <FormattedMessage {...messages.endorsementChangeServiceRequested} />,
  [ReturnServiceRequested]: <FormattedMessage {...messages.endorsementReturnServiceRequested} />,
};

export const getLabelForEndorsementType = (endorseType) => mapForMessages[endorseType];
